import { GET_USERS_LIST, GET_WORKSTATIONS_LIST } from '../../types'

const initialState = {
  users: [],
  workstations: []
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_USERS_LIST: return {
      ...state,
      users: action.payload
    }
    case GET_WORKSTATIONS_LIST: return {
      ...state,
      workstations: action.payload
    }
    default: return { ...state }
  }
}
